import React, { FC } from 'react'
import { Popover, message } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import styles from './Roles.module.less'
import { AssignToUser } from './AssignToUser'
import { OrgRoleItemResponse } from '~/Services/OrganizationService'
import { useAppDispatch, useAppSelector } from '~/Store/hooks'
import { getRoleModalVisibility } from '~/Store/Organization/selectors'
import { assignRoleModalName } from './constant'
import { OrganizationActions } from '~/Store/Organization'
import { getOrganizationUsers } from '~/Store/Organization/selectors'

interface AssignRoleExtraProps {
  role: OrgRoleItemResponse
}

export const AssignRoleExtra: FC<AssignRoleExtraProps> = ({ role }) => {
  const dispatch = useAppDispatch()
  const modalName = `${assignRoleModalName}_${role.name}`
  const visibility = useAppSelector(getRoleModalVisibility(modalName))
  const orgUsers = useAppSelector(getOrganizationUsers)
  

  const toggleAssignToUsers = (nextVisible: boolean) => {
    if (nextVisible === true) {
      const isSingleUserRole = role.name === 'SuperUser'

      const userCount = orgUsers.filter(u =>
        u.organizationRoles?.includes(role.name),
      ).length

      if (isSingleUserRole && userCount >= 1) {
        message.error('Role này chỉ được 1 người')

        dispatch(
          OrganizationActions.setModalState({
            name: modalName,
            value: false,
          }),
        )
        return
      }
    }

    
    dispatch(
      OrganizationActions.setModalState({
        name: modalName,
        value: nextVisible,
      }),
    )
  }

  return (
    <div
      className={styles.extraAssignIcon}
      onClick={event => {
        dispatch(OrganizationActions.setRoleActivePanel(role.id))
        event.stopPropagation()
      }}
    >
      <Popover
        placement="leftTop"
        title="Assign to users"
        content={<AssignToUser role={role} />}
        trigger="click"
        visible={visibility}
        onVisibleChange={toggleAssignToUsers}
      >
        <PlusOutlined />
      </Popover>
    </div>
  )
}
